import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Tooltip } from 'react-tippy';
import ALL_THEATERS_DETAILED_QUERY from '../../../../graphql/AllTheatersDetailed';
import Banner from '../../../../components/Banner';
import Footer from '../../../../components/Footer';
import Sidebar from '../../../../components/Sidebar';
import Toggle from '../Toggle';
import ToggleStats from '../ToggleStats';
import Delete from '../Delete';
import { IsAdmin } from '../../../../utils/Roles';


class TheaterList extends Component {
  componentWillMount() {
    if (!IsAdmin()) {
      this.props.history.push('/login');
    }
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  editActionFormatter = (cell, row) => {
    const { id } = row;
    return (
      <div>
        <Tooltip
          title="Editar"
          position="bottom"
          trigger="mouseenter"
        >
          <Link to={`/admin/theater/${id}`} className="btn btn-info">
            <i className="fa fa-pencil" aria-hidden="true" />
          </Link>
        </Tooltip>
        <Toggle id={row.id} status={row.active} />
        <ToggleStats id={row.id} status={row.enabledStats} />
        <Delete id={row.id} onDelete={() => this.props.refetch()} />
      </div>
    );
  };

  render() {
    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="theaters" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Mantenedor de Teatros</h1>

                <div className="row">
                  <div className="col-md-12">
                    <div className="button-section pull-right">
                      <p>
                        <Link
                          to="/admin/theater/new"
                          className="btn button-sm button-theme"
                        >
                          Nuevo Teatro
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
                <BootstrapTable
                  data={this.props.theaters || []}
                  striped
                  hover
                  pagination
                >
                  <TableHeaderColumn isKey dataField="id" dataSort hidden>
                    ID
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="name"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Nombre
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="address"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Dirección
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="action"
                    dataFormat={this.editActionFormatter}
                  >
                    Acciones
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withTheaters = graphql(ALL_THEATERS_DETAILED_QUERY, {
  options: () => ({
    variables: { force: true },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    theaters: data.allTheaters,
    refetch: data.refetch,
  }),
});

export default withTheaters(TheaterList);



// WEBPACK FOOTER //
// ./src/containers/Admin/Theater/List/index.js